module.exports = __webpack_public_path__ + "static/media/passsystem.fbda167f.png";